export const customClass = "c1axpy2i";
export const container = "c10z3e61";
export const buttonContainer = "bxxxepo";
export const imageContainer = "i1egjjfs";
export const heading = "h1y360x3";
export const subheading = "si4v4dc";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");